module.exports = __webpack_public_path__ + "img/logo-gray.add169f9.png";